/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation userUpdateUserPasswordMutation($username: String!, $password: String!) {
        changeUserPassword(username: $username, password: $password)
    }
`;
